/**
 * sl-apue: SeatAddonService — Manages workspace seat addon lifecycle
 */
import { Service } from '@toeverything/infra';

import { SeatAddon } from '../entities/seat-addon';

export class SeatAddonService extends Service {
  seatAddon = this.framework.createEntity(SeatAddon);
}
